/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const WorkTimeType = {
    DEFAULT: 'DEFAULT',
    CUSTOM: 'CUSTOM'
} as const;
export type WorkTimeType = typeof WorkTimeType[keyof typeof WorkTimeType];

